
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 37"><g fill="#666" fill-rule="nonzero"><path d="M13.5.5h6v27.4c-3 .6-5.3.8-7.7.8-7.2 0-11-3.3-11-9.5 0-6 4-10 10.2-10 1 0 1.7.1 2.6.3v-9h-.1zm0 13.8c-.7-.2-1.3-.3-2-.3-3 0-4.7 1.8-4.7 5.1 0 3.2 1.7 4.9 4.7 4.9.7 0 1.2 0 2-.2v-9.5z"/><path d="M28.9 9.7v13.7c0 4.7-.3 7-1.4 9-1 1.9-2.2 3.1-4.8 4.4l-5.5-2.6c2.6-1.2 3.9-2.3 4.7-4s1.1-3.7 1.1-8.8V9.7h5.9zM23 .6h5.9v6.1H23z"/></g></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    